<div>
  <fieldset class="now-input-group">
    <legend class="nowrap-text">
      <div class="d-flex align-items-center">
        Welches Ziel verfolgen Sie mit der Weiterbildung?
        <button
          [attr.data-bs-target]="'#modal-bildungsbereich-info'"
          aria-label="Mehr Informationen zum Bildungsbereich"
          data-bs-toggle="modal"
          id="bildungsbereich-info_modal_button"
          class="now-context-icon-btn now-icon now-icon-info small"
        ></button>
      </div>
    </legend>
    <div class="now-btn-group" role="radiogroup">
      <div class="form-check">
        <input
          type="radio"
          name="bildungsbereich"
          id="wissen_erweitern"
          (click)="setBildungsbereich($event, BildungsBereich.Erweitern)"
          [checked]="isChecked(BildungsBereich.Erweitern) | async"
        />
        <label for="wissen_erweitern">Wissen erweitern</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="bildungsbereich"
          id="abschluss_erwerben"
          (click)="setBildungsbereich($event, BildungsBereich.Erwerb)"
          [checked]="isChecked(BildungsBereich.Erwerb) | async"
        />
        <label for="abschluss_erwerben">Neuen Abschluss erwerben</label>
      </div>
    </div>
  </fieldset>
</div>
<now-wbsuche-lib-modal-popup
  #bildungsbereichWechselnModal
  modalId="modal-bildungsbereich-wechsel"
  modalTitle="Weiterbildungsziel ändern"
  primaryButtonText="Auswahl ändern"
  secondaryButtonText="Abbrechen"
  [primaryBeforeSecondary]="false"
  ariaLabel="Hinweis zum Wechsel des Bildungsbereichs"
>
  Wenn Sie Ihr Weiterbildungsziel ändern, werden alle Filter außer „Ort“ und „Umkreis“
  zurückgesetzt. Ihre Sucheingabe bleibt bestehen. Möchten Sie fortfahren?
</now-wbsuche-lib-modal-popup>
<now-wbsuche-lib-modal-popup
  modalId="modal-bildungsbereich-info"
  modalTitle="Weiterbildungsziel"
  primaryButtonText="Ok"
  secondaryButtonText=""
  ariaLabel="Hinweis zum Weiterbildungsziel"
>
  <p>Weiterbildungen verfolgen unterschiedliche Ziele:</p>
  <h3 class="h6">Wissen erweitern</h3>
  <p>
    Sie möchten Ihr fachliches Wissen auffrischen oder erweitern. Oder: Sie möchten Ihr Wissen
    ausbauen, um im Job aufzusteigen.
  </p>
  <h3 class="h6">Neuen Abschluss erwerben</h3>
  <p>
    Sie möchten mit einer Umschulung einen neuen Beruf erwerben. Oder: Sie möchten einen
    Berufsabschluss schrittweise vorbereiten – mit der sogenannten Teilqualifizierung oder der
    Vorbereitung auf eine Externenprüfung.
  </p>
</now-wbsuche-lib-modal-popup>
